// Life & Wealth Solutions V6 - CRM Dashboard
// Phoenix Rescue Apps - CRM Overview

import React from 'react';
import { Link } from 'react-router-dom';

const CRMDashboard: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">CRM Overview</h1>
        <p className="text-gray-500 mt-1">Manage your customer relationships</p>
      </div>

      {/* Pipeline Overview */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {['Lead', 'Qualified', 'Proposal', 'Closed'].map((stage, idx) => (
          <div key={idx} className="bg-white rounded-lg shadow border border-gray-200 p-6">
            <h3 className="text-sm font-medium text-gray-500">{stage}</h3>
            <p className="mt-2 text-3xl font-bold text-gray-900">{Math.floor(Math.random() * 50) + 10}</p>
            <p className="mt-2 text-sm text-green-600">↑ {Math.floor(Math.random() * 20)}% from last week</p>
          </div>
        ))}
      </div>

      {/* Quick Links */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Link to="/leads" className="bg-white rounded-lg shadow border border-gray-200 p-6 hover:shadow-lg transition-shadow">
          <h3 className="text-lg font-bold text-gray-900">Manage Leads</h3>
          <p className="text-gray-500 mt-2">View and manage all your leads</p>
        </Link>
        <Link to="/contacts" className="bg-white rounded-lg shadow border border-gray-200 p-6 hover:shadow-lg transition-shadow">
          <h3 className="text-lg font-bold text-gray-900">Contact Database</h3>
          <p className="text-gray-500 mt-2">Access your contact information</p>
        </Link>
        <Link to="/deals" className="bg-white rounded-lg shadow border border-gray-200 p-6 hover:shadow-lg transition-shadow">
          <h3 className="text-lg font-bold text-gray-900">Deal Pipeline</h3>
          <p className="text-gray-500 mt-2">Track deals through your pipeline</p>
        </Link>
      </div>
    </div>
  );
};

export default CRMDashboard;
